"use strict";

var _objectWithoutProperties = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _objectSpread = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _asyncToGenerator = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var mobx_state_tree_1 = require("mobx-state-tree");
var json_stable_stringify_1 = __importDefault(require("json-stable-stringify"));
var abortable_promise_cache_1 = __importDefault(require("abortable-promise-cache"));
// locals
var configuration_1 = require("../configuration");
var util_1 = require("../util");
var QuickLRU_1 = __importDefault(require("../util/QuickLRU"));
var refNameRegex = new RegExp('[0-9A-Za-z!#$%&+./:;?@^_|~-][0-9A-Za-z!#$%&*+./:;=?@^_|~-]*');
// Based on the UCSC Genome Browser chromosome color palette:
// https://github.com/ucscGenomeBrowser/kent/blob/a50ed53aff81d6fb3e34e6913ce18578292bc24e/src/hg/inc/chromColors.h
// Some colors darkened to have at least a 3:1 contrast ratio on a white
// background
var refNameColors = ['rgb(153, 102, 0)', 'rgb(102, 102, 0)', 'rgb(153, 153, 30)', 'rgb(204, 0, 0)', 'rgb(255, 0, 0)', 'rgb(255, 0, 204)', 'rgb(165, 132, 132)', 'rgb(204, 122, 0)', 'rgb(178, 142, 0)', 'rgb(153, 153, 0)', 'rgb(122, 153, 0)', 'rgb(0, 165, 0)', 'rgb(53, 128, 0)', 'rgb(0, 0, 204)', 'rgb(96, 145, 242)', 'rgb(107, 142, 178)', 'rgb(0, 165, 165)', 'rgb(122, 153, 153)', 'rgb(153, 0, 204)', 'rgb(204, 51, 255)', 'rgb(173, 130, 216)', 'rgb(102, 102, 102)', 'rgb(145, 145, 145)', 'rgb(142, 142, 142)', 'rgb(142, 142, 107)', 'rgb(96, 163, 48)' // originally 'rgb(121, 204, 61)'
];
function loadRefNameMap(_x, _x2, _x3, _x4) {
  return _loadRefNameMap.apply(this, arguments);
} // Valid refName pattern from https://samtools.github.io/hts-specs/SAMv1.pdf
function _loadRefNameMap() {
  _loadRefNameMap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(assembly, adapterConfig, options, signal) {
    var sessionId, refNames, refNameAliases, refNameMap, reversed;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          sessionId = options.sessionId;
          _context5.next = 3;
          return (0, util_1.when)(function () {
            return !!(assembly.regions && assembly.refNameAliases);
          }, {
            signal: signal,
            name: 'when assembly ready'
          });
        case 3:
          _context5.next = 5;
          return assembly.rpcManager.call(sessionId, 'CoreGetRefNames', _objectSpread({
            adapterConfig: adapterConfig,
            signal: signal
          }, options), {
            timeout: 1000000
          });
        case 5:
          refNames = _context5.sent;
          refNameAliases = assembly.refNameAliases;
          if (refNameAliases) {
            _context5.next = 9;
            break;
          }
          throw new Error("error loading assembly ".concat(assembly.name, "'s refNameAliases"));
        case 9:
          refNameMap = Object.fromEntries(refNames.map(function (name) {
            checkRefName(name);
            return [assembly.getCanonicalRefName(name), name];
          })); // make the reversed map too
          reversed = Object.fromEntries(Object.entries(refNameMap).map(function (_ref5) {
            var _ref6 = _slicedToArray(_ref5, 2),
              canonicalName = _ref6[0],
              adapterName = _ref6[1];
            return [adapterName, canonicalName];
          }));
          return _context5.abrupt("return", {
            forwardMap: refNameMap,
            reverseMap: reversed
          });
        case 12:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _loadRefNameMap.apply(this, arguments);
}
function checkRefName(refName) {
  if (!refName.match(refNameRegex)) {
    throw new Error("Encountered invalid refName: \"".concat(refName, "\""));
  }
}
function getAdapterId(adapterConf) {
  return (0, json_stable_stringify_1.default)(adapterConf);
}
function assemblyFactory(assemblyConfigType, pm) {
  var adapterLoads = new abortable_promise_cache_1.default({
    cache: new QuickLRU_1.default({
      maxSize: 1000
    }),
    fill: function () {
      var _fill = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(args, signal, statusCallback) {
        var adapterConf, self, options;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              adapterConf = args.adapterConf, self = args.self, options = args.options;
              return _context.abrupt("return", loadRefNameMap(self, adapterConf, _objectSpread({}, options, {
                statusCallback: statusCallback
              }), signal));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function fill(_x5, _x6, _x7) {
        return _fill.apply(this, arguments);
      }
      return fill;
    }()
  });
  return mobx_state_tree_1.types.model({
    configuration: mobx_state_tree_1.types.safeReference(assemblyConfigType)
  }).volatile(function () {
    return {
      error: undefined,
      loaded: false,
      loadingP: undefined,
      volatileRegions: undefined,
      refNameAliases: undefined,
      lowerCaseRefNameAliases: undefined,
      cytobands: undefined
    };
  }).views(function (self) {
    return {
      get initialized() {
        // @ts-ignore
        self.load();
        return !!self.refNameAliases;
      },
      get name() {
        return (0, configuration_1.getConf)(self, 'name');
      },
      get regions() {
        // @ts-ignore
        self.load();
        return self.volatileRegions;
      },
      get aliases() {
        return (0, configuration_1.getConf)(self, 'aliases');
      },
      get displayName() {
        return (0, configuration_1.getConf)(self, 'displayName');
      },
      hasName: function hasName(name) {
        return this.allAliases.includes(name);
      },
      get allAliases() {
        return [this.name].concat(_toConsumableArray(this.aliases));
      },
      // note: lowerCaseRefNameAliases not included here: this allows the list
      // of refnames to be just the "normal casing", but things like
      // getCanonicalRefName can resolve a lower-case name if needed
      get allRefNames() {
        return !self.refNameAliases ? undefined : Object.keys(self.refNameAliases);
      },
      get lowerCaseRefNames() {
        return !self.lowerCaseRefNameAliases ? undefined : Object.keys(self.lowerCaseRefNameAliases || {});
      },
      get allRefNamesWithLowerCase() {
        return this.allRefNames && this.lowerCaseRefNames ? _toConsumableArray(new Set([].concat(_toConsumableArray(this.allRefNames), _toConsumableArray(this.lowerCaseRefNames)))) : undefined;
      },
      get rpcManager() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (0, mobx_state_tree_1.getParent)(self, 2).rpcManager;
      },
      get refNameColors() {
        var colors = (0, configuration_1.getConf)(self, 'refNameColors');
        return colors.length === 0 ? refNameColors : colors;
      }
    };
  }).views(function (self) {
    return {
      get refNames() {
        var _a;
        return (_a = self.regions) === null || _a === void 0 ? void 0 : _a.map(function (region) {
          return region.refName;
        });
      }
    };
  }).views(function (self) {
    return {
      getCanonicalRefName: function getCanonicalRefName(refName) {
        if (!self.refNameAliases || !self.lowerCaseRefNameAliases) {
          throw new Error('aliases not loaded, we expect them to be loaded before getCanonicalRefName can be called');
        }
        return self.refNameAliases[refName] || self.lowerCaseRefNameAliases[refName];
      },
      getRefNameColor: function getRefNameColor(refName) {
        if (!self.refNames) {
          return undefined;
        }
        var idx = self.refNames.findIndex(function (r) {
          return r === refName;
        });
        if (idx === -1) {
          return undefined;
        }
        return self.refNameColors[idx % self.refNameColors.length];
      },
      isValidRefName: function isValidRefName(refName) {
        if (!self.refNameAliases) {
          throw new Error('isValidRefName cannot be called yet, the assembly has not finished loading');
        }
        return !!this.getCanonicalRefName(refName);
      }
    };
  }).actions(function (self) {
    return {
      setLoaded: function setLoaded(_ref) {
        var adapterRegionsWithAssembly = _ref.adapterRegionsWithAssembly,
          refNameAliases = _ref.refNameAliases,
          lowerCaseRefNameAliases = _ref.lowerCaseRefNameAliases,
          cytobands = _ref.cytobands;
        self.loaded = true;
        this.setRegions(adapterRegionsWithAssembly);
        this.setRefNameAliases(refNameAliases, lowerCaseRefNameAliases);
        this.setCytobands(cytobands);
      },
      setError: function setError(e) {
        console.error(e);
        self.error = e;
      },
      setRegions: function setRegions(regions) {
        self.volatileRegions = regions;
      },
      setRefNameAliases: function setRefNameAliases(aliases, lcAliases) {
        self.refNameAliases = aliases;
        self.lowerCaseRefNameAliases = lcAliases;
      },
      setCytobands: function setCytobands(cytobands) {
        self.cytobands = cytobands;
      },
      setLoadingP: function setLoadingP(p) {
        self.loadingP = p;
      },
      load: function load() {
        var _this = this;
        if (!self.loadingP) {
          self.loadingP = this.loadPre().catch(function (e) {
            _this.setLoadingP(undefined);
            _this.setError(e);
          });
        }
        return self.loadingP;
      },
      loadPre: function () {
        var _loadPre = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          var _a, _b, conf, refNameAliasesAdapterConf, cytobandAdapterConf, sequenceAdapterConf, assemblyName, regions, adapterRegionsWithAssembly, refNameAliases, ret, cytobands, lowerCaseRefNameAliases;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                conf = self.configuration;
                refNameAliasesAdapterConf = (_a = conf.refNameAliases) === null || _a === void 0 ? void 0 : _a.adapter;
                cytobandAdapterConf = (_b = conf.cytobands) === null || _b === void 0 ? void 0 : _b.adapter;
                sequenceAdapterConf = conf.sequence.adapter;
                assemblyName = self.name;
                _context2.next = 7;
                return getAssemblyRegions(sequenceAdapterConf, pm);
              case 7:
                regions = _context2.sent;
                adapterRegionsWithAssembly = regions.map(function (r) {
                  checkRefName(r.refName);
                  return _objectSpread({}, r, {
                    assemblyName: assemblyName
                  });
                });
                refNameAliases = {};
                _context2.next = 12;
                return getRefNameAliases(refNameAliasesAdapterConf, pm);
              case 12:
                ret = _context2.sent;
                _context2.next = 15;
                return getCytobands(cytobandAdapterConf, pm);
              case 15:
                cytobands = _context2.sent;
                ret.forEach(function (_ref2) {
                  var refName = _ref2.refName,
                    aliases = _ref2.aliases;
                  aliases.forEach(function (a) {
                    checkRefName(a);
                    refNameAliases[a] = refName;
                  });
                });
                // add identity to the refNameAliases list
                adapterRegionsWithAssembly.forEach(function (region) {
                  refNameAliases[region.refName] = region.refName;
                });
                lowerCaseRefNameAliases = Object.fromEntries(Object.entries(refNameAliases).map(function (_ref3) {
                  var _ref4 = _slicedToArray(_ref3, 2),
                    key = _ref4[0],
                    val = _ref4[1];
                  return [key.toLowerCase(), val];
                }));
                this.setLoaded({
                  adapterRegionsWithAssembly: adapterRegionsWithAssembly,
                  refNameAliases: refNameAliases,
                  lowerCaseRefNameAliases: lowerCaseRefNameAliases,
                  cytobands: cytobands
                });
              case 20:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this);
        }));
        function loadPre() {
          return _loadPre.apply(this, arguments);
        }
        return loadPre;
      }()
    };
  }).views(function (self) {
    return {
      getAdapterMapEntry: function getAdapterMapEntry(adapterConf, options) {
        var signal = options.signal,
          statusCallback = options.statusCallback,
          rest = _objectWithoutProperties(options, ["signal", "statusCallback"]);
        if (!options.sessionId) {
          throw new Error('sessionId is required');
        }
        var adapterId = getAdapterId(adapterConf);
        return adapterLoads.get(adapterId, {
          adapterConf: adapterConf,
          self: self,
          options: rest
        },
        // signal intentionally not passed here, fixes issues like #2221.
        // alternative fix #2540 was proposed but non-working currently
        undefined, statusCallback);
      },
      /**
       * get Map of `canonical-name -> adapter-specific-name`
       */
      getRefNameMapForAdapter: function () {
        var _getRefNameMapForAdapter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(adapterConf, opts) {
          var map;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!opts || !opts.sessionId)) {
                  _context3.next = 2;
                  break;
                }
                throw new Error('sessionId is required');
              case 2:
                _context3.next = 4;
                return this.getAdapterMapEntry(adapterConf, opts);
              case 4:
                map = _context3.sent;
                return _context3.abrupt("return", map.forwardMap);
              case 6:
              case "end":
                return _context3.stop();
            }
          }, _callee3, this);
        }));
        function getRefNameMapForAdapter(_x8, _x9) {
          return _getRefNameMapForAdapter.apply(this, arguments);
        }
        return getRefNameMapForAdapter;
      }(),
      /**
       * get Map of `adapter-specific-name -> canonical-name`
       */
      getReverseRefNameMapForAdapter: function () {
        var _getReverseRefNameMapForAdapter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(adapterConf, opts) {
          var map;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getAdapterMapEntry(adapterConf, opts);
              case 2:
                map = _context4.sent;
                return _context4.abrupt("return", map.reverseMap);
              case 4:
              case "end":
                return _context4.stop();
            }
          }, _callee4, this);
        }));
        function getReverseRefNameMapForAdapter(_x10, _x11) {
          return _getReverseRefNameMapForAdapter.apply(this, arguments);
        }
        return getReverseRefNameMapForAdapter;
      }()
    };
  });
}
exports.default = assemblyFactory;
function getRefNameAliases(_x12, _x13, _x14) {
  return _getRefNameAliases.apply(this, arguments);
}
function _getRefNameAliases() {
  _getRefNameAliases = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(config, pm, signal) {
    var type, CLASS, adapter;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          type = pm.getAdapterType(config.type);
          _context6.next = 3;
          return type.getAdapterClass();
        case 3:
          CLASS = _context6.sent;
          adapter = new CLASS(config, undefined, pm);
          return _context6.abrupt("return", adapter.getRefNameAliases({
            signal: signal
          }));
        case 6:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _getRefNameAliases.apply(this, arguments);
}
function getCytobands(_x15, _x16) {
  return _getCytobands.apply(this, arguments);
}
function _getCytobands() {
  _getCytobands = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(config, pm) {
    var type, CLASS, adapter;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          type = pm.getAdapterType(config.type);
          _context7.next = 3;
          return type.getAdapterClass();
        case 3:
          CLASS = _context7.sent;
          adapter = new CLASS(config, undefined, pm); // @ts-ignore
          return _context7.abrupt("return", adapter.getData());
        case 6:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _getCytobands.apply(this, arguments);
}
function getAssemblyRegions(_x17, _x18, _x19) {
  return _getAssemblyRegions.apply(this, arguments);
}
function _getAssemblyRegions() {
  _getAssemblyRegions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(config, pm, signal) {
    var type, CLASS, adapter;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          type = pm.getAdapterType(config.type);
          _context8.next = 3;
          return type.getAdapterClass();
        case 3:
          CLASS = _context8.sent;
          adapter = new CLASS(config, undefined, pm);
          return _context8.abrupt("return", adapter.getRegions({
            signal: signal
          }));
        case 6:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _getAssemblyRegions.apply(this, arguments);
}